import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpAuthorizationHeader } from '../misc/httpauthorizationheader';
import { CreditInformationType } from '../state/types/credit-information.types';
import { KvkInformationType } from '../state/types/kvk-information.types';
import { BLService } from './bl.service';

@Injectable({
  providedIn: 'root',
})
export class CreditInformationService extends BLService {
  private options = new HttpAuthorizationHeader('application/json');
  private RESOURCE_ENDPOINT = 'information-logistics/info/';
  private url = environment.serverUrlV2 + this.RESOURCE_ENDPOINT;

  getSwedishCreditInformation(corporateIdentity: string): Observable<CreditInformationType> {
    return this.http
      .get<
        CreditInformationType & { error: string }
      >(this.url + corporateIdentity, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(
        map((response) => {
          if (!response) {
            return null;
          }

          if (!Object.keys(response).length) {
            return null;
          }

          const { error, ...creditInformation } = response;
          if (error) {
            throw { error: { message: error } };
          }

          return creditInformation;
        }),
        this.catchErrorAndShowMessage(),
      );
  }

  getDutchCompanyInformation(kvkNumber: string): Observable<KvkInformationType> {
    return this.http
      .get<KvkInformationType>(`${this.url}kvk/${kvkNumber}`, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }
}
